module.exports = __webpack_public_path__ + "img/1021.b76c032f.svg";